<template>
  <layout-admin current="leads">
    <div class="panel">
      <div class="panel__head">
        <h1>Leads</h1>
        <span>{{ leads.length }}</span>
      </div>

      <div v-if="!leads.length" class="panel__empty">No leads yet.</div>

      <div v-else class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Status</th>
              <th>Reply</th>
              <th>Language</th>
              <th>Threads</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lead in leads" :key="lead.id">
              <td>{{ lead.id }}</td>
              <td>
                <Link
                  v-if="lead.latest_thread_id"
                  :href="route('admin.inbox.threads', lead.latest_thread_id)"
                  class="link"
                >
                  {{ lead.name || '—' }}
                </Link>
                <span v-else>{{ lead.name || '—' }}</span>
              </td>
              <td>{{ lead.phone || '—' }}</td>
              <td>{{ lead.email || '—' }}</td>
              <td><span class="pill">{{ lead.status || '-' }}</span></td>
              <td><span class="pill">{{ lead.reply_mode === 'manual' ? 'Manual' : 'AI' }}</span></td>
              <td>{{ lead.preferred_language || '-' }}</td>
              <td>
                <Link
                  v-if="lead.latest_thread_id"
                  :href="route('admin.inbox.threads', lead.latest_thread_id)"
                  class="link"
                >
                  {{ lead.thread_count }}
                </Link>
                <span v-else>{{ lead.thread_count }}</span>
              </td>
              <td>{{ formatDate(lead.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-admin>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import LayoutAdmin from '@/Layouts/Admin.vue';

export default {
  components: {
    LayoutAdmin,
    Link
  },

  props: {
    leads: { type: Array, required: true }
  },

  methods: {
    formatDate(iso) {
      if (!iso) return '—';
      return new Date(iso).toLocaleString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>
